// ESM-Huelle fuer lib/scripts/FNC_main.js (ESM-Welle 5c) - der Legacy-Boot.
// Originalquelltext uebernommen; Aenderungen NUR nach Runbook-Regel 1d:
// die 24 Top-Level-vars waren als Classic-Skript window-Globals (POS, log,
// fs, require, CryptoJS, rs, Buffer, qrcode, ... - von 98/58/20/... Dateien
// nackt gelesen) und sind deshalb ZEICHENGENAU auf window.<name> umgeschrieben
// (Schreib- UND Lesestellen; Strings/Kommentare unangetastet). Die 11 Top-
// Level-Funktionen bleiben Deklarationen und werden exportiert; die Bridge
// publiziert sie als window.* (index.html: <body onUnload="unInit ();">).
// Parse-Zeit-Seiteneffekte (wie im Classic-Skript): debugger; die vier
// synchronen require()-Ladungen der Krypto-Bibliotheken; die Registrierung
// von $(document).ready(run). Die Datei war bereits komplett 'use strict'.
// Diese Huelle wird in legacy-bridge.js als ERSTER Import gefuehrt, damit
// die Boot-Globals existieren, bevor ein anderes Modul evaluiert - exakt
// die Reihenfolge des Classic-Skripts (stand VOR dem Bundle).
import { QRCodeFactory } from '../receipt/qrcode.js';
'use strict';
window.resize = true;
//var window = Window;
window.getScript = function(url){
    var path = url.substring(0,url.lastIndexOf("\/")+1);
    if (url.toLowerCase().substr(-3)!=='.js') url+='.js'; // to allow loading without js suffix;
            try {
                var X=new XMLHttpRequest();
                X.open("GET", url, 0); // sync
                X.send();
                if (X.status && X.status !== 200)  throw new Error(X.statusText);
                var source = X.responseText;
		source = source+"\n//# sourceURL="+location.host+"/"+url;
		 jQuery.globalEval(source);
 		} catch (err) {
                console.log("Error loading script module "+url+": "+err);
            	}
}

debugger;

window.require = function(url){
    var path = url.substring(0,url.lastIndexOf("\/")+1);
    if (url.toLowerCase().substr(-3)!=='.js') url+='.js'; // to allow loading without js suffix;
    if (!window.require.cache) window.require.cache=[]; //init cache
    var exports=window.require.cache[url]; //get from cache
    if (!exports) { //not cached
            try {
                exports={};
                var X=new XMLHttpRequest();
                X.open("GET", url, 0); // sync
                X.send();
                if (X.status && X.status !== 200)  throw new Error(X.statusText);
                var source = X.responseText;
                // fix (if saved form for Chrome Dev Tools)
                if (source.substr(0,10)==="(function("){ 
                    var moduleStart = source.indexOf('{');
                    var moduleEnd = source.lastIndexOf('})');
                    var CDTcomment = source.indexOf('//@ ');
                    if (CDTcomment>-1 && CDTcomment<moduleStart+6) moduleStart = source.indexOf('\n',CDTcomment);
                    source = source.slice(moduleStart+1,moduleEnd-1); 
                }
		var searchstr = "require('./";
		var x = source.indexOf(searchstr);
		while ( x > -1){
				var replCharsAt = function(str,index,chr, searchstr) {
    					if(index > str.length-1) return str;
    					return str.substr(0,index) + chr + str.substr(index+searchstr.length);
				}
				source = replCharsAt(source,x,"require('"+path, searchstr);
				//source = source.replace(/\.\//g,path);
				x =  source.indexOf(searchstr,x+1);
		} 
                // fix, add comment to show source on Chrome Dev Tools
                //source="//@ sourceURL="+Window.location.origin+url+"\n" + source;
                //------
                var module = { id: url, uri: url, exports:exports }; //according to node.js modules 
                var anonFn = new Function("require", "exports", "module", source); //create a Fn with module code, and 3 params: require, exports & module
                anonFn(window.require, exports, module); // call the Fn, Execute the module
                window.require.cache[url]  = exports = module.exports; //cache obj exported by module
            } catch (err) {
                console.log("Error loading module "+url+": "+err);
            }
    }
    return exports; //require returns object exported by module
}
///- END REQUIRE FNfunction require(url){
//var require;
//import * as _net_ from 'net';
//var CryptoJS = require('../../node_modules/crypto-js/crypto-js.js');
//var node_cryptojs =require('../../node_modules/node-cryptojs-aes/cryptojs.js');
//var rs = require('../../node_modules/jsrsasign/lib/jsrsasign.js');

window.CryptoJS = window.require('../../lib/jQuery/crypto/crypto-js.js');
window.node_cryptojs =window.require('../../lib/jQuery/crypto/cryptojs.js');
window.rs = window.require('../../lib/jQuery/crypto/jsrsasign.js');



window.Buffer = window.require('../../lib/jQuery/buffer.js').Buffer;
window.fs = null; //new CFileHandler();// = require('fs');
window.log = null;
//var pcsc=require('../../node_modules/pcsclite/index.js');

//var net = 
//var SerialPort = require("serialport").SerialPort;
window.test = true;
//var qr;//= QRCodeFactory;
window.qrcode = null;
//var net = require('net');
// ESM-Welle 5c: war 'var privMan, ..., now;' OHNE Initialwert. Classic-
// Semantik exakt nachgebildet: window-Property anlegen (undefined), einen
// schon vorhandenen Wert aber NICHT ueberschreiben (var ueberschreibt nie).
// Cross-file gelesen: POS (ueberall), silent (core/sound.js, nackter Lese-
// Guard!), UIDParam (pos/cpos.js), now (11 Dateien; Slot wird per window.now
// beschrieben). Die uebrigen einheitlich mit, weil die Websocket-Payloads des
// Zentralservers per eval ausgefuehrt werden - dort ist jeder Name moeglich.
// Der eval sitzt seit 25.8.2026 in lib/scripts/pos/netcomm/legacy-eval.js
// (der Rest des Clients ist frontend/src/netcomm/runclient.js).
if (!('privMan' in window)) window.privMan = undefined;
if (!('privList' in window)) window.privList = undefined;
if (!('includes' in window)) window.includes = undefined;
if (!('includeCount' in window)) window.includeCount = undefined;
if (!('includeCheck' in window)) window.includeCheck = undefined;
if (!('loopCount' in window)) window.loopCount = undefined;
if (!('UIDParam' in window)) window.UIDParam = undefined;
if (!('POS' in window)) window.POS = undefined;
if (!('silent' in window)) window.silent = undefined;
if (!('keyboard' in window)) window.keyboard = undefined;
if (!('mustNotOpen' in window)) window.mustNotOpen = undefined;
if (!('now' in window)) window.now = undefined;

window.haserror=false;

//var document = null;

$(document).ready(function() {

   /*require = function() {
        //$.each(arguments, function(i, script) {
        var script = arguments[0];
	var func = arguments[1];  
  	if ($('head script[src="' + script + '"]').length == 0) {
                //document.write('<script type="text/javascript" src="' + script + '"></scri'+'pt>');
		var s = document.createElement('script');
		s.onload = function() {
			func();	
		}
		s.src = script;
		document.getElementsByTagName('head')[0].appendChild(s);
           }
        //});
    };*/
	//require("lib/scripts/CLS_CFileHandler.js", function(){fs=new CFileHandler()});
	window.fs=new CFileHandler();  
 	// $.getScript('lib/scripts/pos/receipt/CLS_CQRCode.js', function() {
	// Seit 25.8.2026 aus dem Buendel statt ueber den require()-Ersatz
	// (frontend/src/receipt/qrcode.js). Der Aufruf bleibt an dieser Stelle -
	// die Fabrik wird weiterhin ERST hier instanziiert, wenn Buffer und $
	// stehen; die Datei selbst hat keine Ladezeit-Seiteneffekte (geprueft).
	var qr = QRCodeFactory;

	window.qrcode = new  qr({
        doc: document,
        heigth: 200,
        width: 200,
        scaleX: 1,
        scaleY: 1
    		});
  
    run();
});

function runtest() {
    debugger;
    //var gui = require('nw.gui');
   // var win = gui.Window.get();
	setTimeout(function(){
//		Windows.showDevTools();
		setTimeout(function(){
			run();
			testing();
		},2000);
	},2000);
	
	
}

//------------------------------------------------------------------------------
// Description:
//      Convenience function to run the application by simply calling 'run ()'.
//------------------------------------------------------------------------------
function run() {
  //  var gui = require('nw.gui');
  //  window = Window;


    console.log("ready!");
   // document = $(document);

    initLogging();
    var jsarray = include();
    for (var i = 0; i < jsarray.length; i++) {
//        jQuery.globalEval(fs.readFileSync(jsarray[i]) + '');
	var tmpjs = window.getScript(jsarray[i] + '');
    }


    init();

    $("body").css("-webkit-user-select", "none");
    $("body").css("-moz-user-select", "none");
    $("body").css("-ms-user-select", "none");
    $("body").css("-o-user-select", "none");
    $("body").css("user-select", "none");
}
//------------------------------------------------------------------------------

//------------------------------------------------------------------------------
// Description:
//      Makes sure, that all required privileges to run the application are
//      granted.
//------------------------------------------------------------------------------
function ensurePrivileges() {
    /*privMan.enablePrivilege (privList);*/
}
//------------------------------------------------------------------------------

//------------------------------------------------------------------------------
// Description:
//      Clears the cache of fragments from last run.
//------------------------------------------------------------------------------
function clearCache() {
    /*privMan.enablePrivilege (privList);*/

    /* var cS = Components.classes["@mozilla.org/network/cache-service;1"].
    getService(Components.interfaces.nsICacheService);

    cS.evictEntries(Components.interfaces.nsICache.STORE_ANYWHERE);*/
    gui.App.clearCache;
}
//------------------------------------------------------------------------------

//------------------------------------------------------------------------------
// Description:
//      Includes all required Javascript Files in project path.
//------------------------------------------------------------------------------
function include() {
//    var dir = new CDirectoryHandler("lib/scripts");
  //  var strarray = dir.read(true);

    /*  var fh = new CFileHandler ();
    var myDir = fh.getMyDir ();*/

    var includeIt = false;

    /*privMan.enablePrivilege (privList);*/
    // var strarray = includes.d;
    //var deferred = new $.Deferred();
    //var promise = deferred.promise();
    var jsarray = new Array();
    /*
    	for (var i in strarray) {
    		if (/.js$/.test(strarray[i])) {
    			includeIt = true;


    		}
    		if ((/FNC_main.js$/.test(strarray[i])) ||
    			(/CLS_CFileHandler.js$/.test(strarray[i])) ||
    			(/CLS_CDirectoryHandler.js$/.test(strarray[i])) ||
    			(/CLS_CFileLogging.js$/.test(strarray[i])) ||
    			(/CMP_CComponent.js$/.test(strarray[i]))) {
    			includeIt = false;
    		}

    		if (includeIt) {
    			// jl.loadSubScript("file://" + includes[i]);

    			// chaining the promises,
    			// by assigning the new promise to the variable
    			// and returning a promise from the callback
    			//if (strarray[i] != "lib/scripts/pos/netcomm/CLS_CRunClient.js")
    			if (strarray[i].lastIndexOf("lib/scripts/pos/netcomm", 0) != 0)
    			jsarray.push(strarray[i]);

    			//   loadjscssfile(strarray[i],"js");
    		}
    		includeIt = false;
    	}

    		jsarray.push("lib/scripts/pos/netcomm/CLS_COutputStream.js");
    		jsarray.push("lib/scripts/pos/netcomm/CLS_CServerInterface.js");
    		jsarray.push("lib/scripts/pos/netcomm/CLS_CDataListener.js");
    		jsarray.push("lib/scripts/pos/netcomm/CLS_CInputStream.js");
    		jsarray.push("lib/scripts/pos/netcomm/CLS_CRunServer.js");

    */
 
/*   jsarray.push("lib/scripts/pos/netcomm/CLS_CRunClient.js");
    jsarray.push("lib/scripts/pos/components/CMP_CPOSIDScreen.js");
    jsarray.push("lib/scripts/pos/receipt/CLS_CSmartcard.js");
	jsarray.push("lib/scripts/pos/receipt/CLS_CReceipt.js");

    jsarray.push("lib/scripts/pos/CLS_CZVTBankomat.js");	
	jsarray.push("lib/scripts/pos/components/messageboard.js");
    jsarray.push("lib/scripts/pos/components/CMP_CMessages.js");
    jsarray.push("lib/scripts/pos/receipt/CLS_CWebservice.js");
*/
    return jsarray;

}

//------------------------------------------------------------------------------
// Description:
//      Initializes POSysseus (Snake and Prey).
//------------------------------------------------------------------------------

function initLogging() {
    try {
	var myDir=window.fs.getMyDir();
        window.log = new CFileLogging(myDir+"var/log/POSysseus.log");
    } catch (e) {
        alert("Could not initialize base logging.\n\nError: " + e);
        return;
    }
}

function init() {
    /*try {
    log = new CFileLogging("var/log/POSysseus.log");
    } catch (e) {
    alert("Could not initialize base logging.\n\nError: " + e);
    return;
    }*/
    /*privMan.enablePrivilege (privList);*/
    window.onerror = function(message, filename, linenumber, colnumber, e) {
        try {
            window.log.add(1, "Error", "Uncaught", "Uncaught error in: " + filename + ",line: " + linenumber + ",message: " + message);

            alert("Error " + message);
			var stack ="";
            if (e){
				stack = e.stack.replace(/^[^\(]+?[\n$]/gm, '')
					.replace(/^\s+at\s+/gm, '')
					.replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@')
					.split('\n');
			} else {
				// queue ist seit der ESM-Umstellung modul-lokal in sqlite.js -
				// der direkte Zugriff warf hier und endete im Neustart statt im
				// beabsichtigten "return true" (Code-Suche 30.9.2026).
				if (window.POS && POS.SQLiteCon && POS.SQLiteCon.queueLeeren)
					POS.SQLiteCon.queueLeeren();
				return true;
			}
            window.log.add(1, "Error", "Uncaught", "Stack: " + stack);
            if (window.POS.http && window.POS.http.Server) {
                window.POS.http.Server.close();
            }
            try {
                window.POS.Ping.Server.stopServer();
            } catch (e) {}
            location.reload();
            return true; // The exception is handled, don't show to the user.


        } catch (e) {
            location.reload();
            return false;
        }
    }

    try {
        /* var values = parseURLParams(window.location);

        if (values) {
        if (typeof values.UID != "undefined")
        UIDParam = values.UID;

        if (typeof values.noResize != "undefined")
        resize = false;

        if (typeof values.noSounds != "undefined")
        silent = true;
        }*/
    } catch (e) {
        window.log.add(1, "Error", "Could not read parameters.", e);
    }
	
	
    window.POS = new CPOS();
/*    $.when(POS.CheckandUpdate()).then(function(reboot) {
        if (reboot) {
            fs.writeFileSync("tmp/update", "1");
            log.add(4, "Info", "Update erfolgreich -> restart X", "");
            executeCommand("/usr/bin/sudo /bin/kill `pidof X`", "shutdown failed");
            haserror = false;

        } else {
            if (fs.existsSync("tmp/update")) {
                fs.unlinkSync("tmp/update");
            }
        }*/
        window.POS.start();

        if (window.resize && !(window.POS.EnvProperties.NORESIZE == "YES")) {
            //window.enterFullscreen();
            //window.locationbar.visible = false;
            //window.menubar.visible = false;
            //window.personalbar.visible = false;
            //window.statusbar.visible = false;
            //window.toolbar.visible = false;
            window.resizeBy(1, 1);
            window.screenX = window.POS.EnvProperties.SCREENXOFFSET;
            window.screenY = window.POS.EnvProperties.SCREENYOFFSET;
            window.innerWidth = 1024;
            window.innerHeight = 768;

        }
   // });

    // testing();
}
//------------------------------------------------------------------------------

function unInit() {}

function parseURLParams(URL) {
    var param;
    var values = new Array();
    var params = URL.toString();

    if (params.indexOf("?") == -1)
        return null;

    params = params.replace(/.*\?/, "").split(/[;&]/);

    for (var i in params) {
        param = params[i].split("=");
        if (typeof param[1] != "undefined")
            values[decodeURI(param[0])] = decodeURI(param[1]);
        else
            values[decodeURI(param[0])] = null;
    }

    return values;
}

function testing() {
/*
var div = $('<div>').css({ 
    position: "absolute",
    marginLeft: 0, 
    marginTop: 0,
    top: 0, 
    left: 1700,
    height: 200, 
    width: 400
}).appendTo('body');


return;
*/
/*
var w = 900;
var h = 300;
var left = (window.screen.width-1);
var top = 100;//(window.screen.height);

var l =  window.screenX;
var win = window.open("display.html", "_blank", 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width='+w+', height='+h);
win.moveTo(left, top);
debugger;
return;*/
/*
 var width = 650;
    var left = 200;

    left += window.screenX;
 // window.open("http://www.orf.at",'windowName',"width=200,height=100-");
   


var w = 300;
var h = 300;
var left = (window.screen.width/2)-(w/2);
var top = (window.screen.height/2)-(h/2);

//chrome.windows.create({url: "local.html", type: "popup",left: 2500, height: 200, top:100,width: 500});
debugger;

var win = window.open("display.html", "_blank", 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width='+w+', height='+h);
win.moveTo(2500,100);
debugger;


    var windowobj = window.open("http://www.orf.at",'windowName','resizable=0,scrollbars=0,fullscreen=1, left=' + left + ', width=600,toolbar=0, menubar=0,status=1');

var sY = screenY;
        if (sY < 0) {
            sY = 0;
        }
        var totalScreenWidth = (screenX + window.outerWidth + sY);
        if (totalScreenWidth > screen.width) {
            totalScreenWidth = totalScreenWidth / 2;
        } else {
            totalScreenWidth = 0;
        }
        windowobj.moveTo(2000, 100);    
    return 0;



debugger;
exit();
var sc = new CSmartcard();
sc.init();
$.when(sc.getCertificate()).then(function(cert){
	console.log(cert);

})




return;
*/
var dir = 'etc/scripts/belege';
window.fs.readdir(dir,function(err,files){

	//for (var i=0;i<files.length;i++){
	var iterator = function(i){
	if (i<files.length){	
		if (files[i].startsWith('qrcode')){
			var beleg = window.fs.readFileSync(dir+"/"+files[i],"utf-8");
						// RKSV-Umbau: Belegpruefung nur noch ueber Kassenserver -> Zentrale
						// (CWebservice.startWebservice); ws.login/ws.belegpruefung gibt es nicht mehr.
						var ws = new CWebservice();
						ws.startWebservice('belegpruefung', function(success) {
							console.log(success);
							iterator(i+1);
						}, beleg);
		} else {
			iterator(i+1);	
		}
	}
	}
		iterator(0)
	});
}


function scaleImageData(c, imageData, scaleX, scaleY) {
    var scaled = c.createImageData(imageData.width * scaleX, imageData.height * scaleY);

    for (var row = 0; row < imageData.height; row++) {
        for (var col = 0; col < imageData.width; col++) {
            var sourcePixel = [
                imageData.data[(row * imageData.width + col) * 4 + 0],
                imageData.data[(row * imageData.width + col) * 4 + 1],
                imageData.data[(row * imageData.width + col) * 4 + 2],
                imageData.data[(row * imageData.width + col) * 4 + 3]
            ];
            for (var y = 0; y < scaleY; y++) {
                var destRow = parseInt(row * scaleY) + y;
                for (var x = 0; x < scaleX; x++) {
                    var destCol = parseInt(col * scaleX) + x;
                    for (var i = 0; i < 4; i++) {
                        scaled.data[(destRow * scaled.width + destCol) * 4 + i] =
                            sourcePixel[i];
                    }
                }
            }
        }
    }

    return scaled;
}

/*

function scaleImageData(ctx,imageData, scale, scaleY) {
var scaled = ctx.createImageData(imageData.width * scale, imageData.height * scale);
var subLine = ctx.createImageData(scale, 1).data
for (var row = 0; row < imageData.height; row++) {
for (var col = 0; col < imageData.width; col++) {
var sourcePixel = imageData.data.subarray(
(row * imageData.width + col) * 4,
(row * imageData.width + col) * 4 + 4
);
for (var x = 0; x < scale; x++) subLine.set(sourcePixel, x*4)
for (var y = 0; y < scale; y++) {
var destRow = row * scale + y;
var destCol = col * scale;
scaled.data.set(subLine, (destRow * scaled.width + destCol) * 4)
}
}
}

return scaled;
}

 */

/*
dataToBesigned
_R1-AT0_DEMO-CASH-BOX473_123456_2016-01-12T11:34:56_0,00_0,00_0,00_0,00_0,00_ozTcIVfY/Tc=_6954105869084563531_gYzzqvCq84U=
Signaturevalue previousreceit: gYzzqvCq84U=

Certificate serial number 6954105869084563531



*/

export { runtest, run, ensurePrivileges, clearCache, include, initLogging, init, unInit, parseURLParams, testing, scaleImageData };
